/* Header scent-wisp effect — UrbanOudAirNYC
   Soft, translucent smoke-like particles drifting upward behind the header.
   Pure canvas 2D, no dependencies. Pauses off-screen and respects reduced-motion.
   Auto-picks a light or dark smoke palette based on the header's actual
   background so the effect stays visible whether the header sits on a
   solid light bar or transparently over a dark hero image. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  function parseRgb(str) {
    var m = str && str.match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var parts = m[1].split(',').map(function (s) { return parseFloat(s); });
    if (parts.length < 3 || isNaN(parts[0])) return null;
    return { r: parts[0], g: parts[1], b: parts[2], a: parts.length > 3 ? parts[3] : 1 };
  }

  function bgLuminance(el) {
    var node = el;
    var depth = 0;
    while (node && depth < 8) {
      var bg = parseRgb(getComputedStyle(node).backgroundColor);
      if (bg && bg.a > 0.05) {
        return (0.299 * bg.r + 0.587 * bg.g + 0.114 * bg.b) / 255;
      }
      node = node.parentElement;
      depth++;
    }
    return 0.9;
  }

  function init() {
    var header = document.getElementById('header-component');
    if (!header) return;

    var canvas = document.createElement('canvas');
    canvas.id = 'header-wisps-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    header.insertBefore(canvas, header.firstChild);

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var width = 0;
    var height = 0;
    var particles = [];
    var running = true;
    var rafId = null;

    var luminance = bgLuminance(header);
    var onLight = luminance > 0.55;

    var PARTICLE_COUNT = 18;
    var COLORS = onLight
      ? [
          'rgba(150,122,88,ALPHA)',
          'rgba(120,108,96,ALPHA)',
          'rgba(173,150,110,ALPHA)'
        ]
      : [
          'rgba(255,255,255,ALPHA)',
          'rgba(196,232,208,ALPHA)',
          'rgba(230,245,235,ALPHA)'
        ];
    var ALPHA_MIN = onLight ? 0.14 : 0.07;
    var ALPHA_MAX = onLight ? 0.32 : 0.20;

    function resize() {
      var rect = header.getBoundingClientRect();
      width = Math.max(rect.width, 1);
      height = Math.max(rect.height, 1);
      canvas.width = width * dpr;
      canvas.height = height * dpr;
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function rand(min, max) {
      return Math.random() * (max - min) + min;
    }

    function spawn(initial) {
      return {
        x: rand(0, width),
        y: initial ? rand(0, height) : height + rand(10, 40),
        r: rand(16, 42),
        speedY: rand(0.12, 0.32),
        driftAmp: rand(6, 22),
        driftSpeed: rand(0.15, 0.45),
        phase: rand(0, Math.PI * 2),
        baseAlpha: rand(ALPHA_MIN, ALPHA_MAX),
        color: COLORS[Math.floor(rand(0, COLORS.length))],
        life: rand(0, 1)
      };
    }

    function buildParticles() {
      particles = [];
      for (var i = 0; i < PARTICLE_COUNT; i++) {
        particles.push(spawn(true));
      }
    }

    function draw(time) {
      if (!running) return;
      ctx.clearRect(0, 0, width, height);

      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.y -= p.speedY;
        var x = p.x + Math.sin(time * 0.001 * p.driftSpeed + p.phase) * p.driftAmp;

        var fadeZone = height * 0.22;
        var alpha = p.baseAlpha;
        if (p.y < fadeZone) alpha *= Math.max(p.y / fadeZone, 0);
        if (p.y > height - fadeZone) alpha *= Math.max((height - p.y) / fadeZone, 0);
        alpha = Math.max(alpha, 0);

        var color = p.color.replace('ALPHA', alpha.toFixed(3));
        var gradient = ctx.createRadialGradient(x, p.y, 0, x, p.y, p.r);
        gradient.addColorStop(0, color);
        gradient.addColorStop(1, p.color.replace('ALPHA', '0'));

        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.arc(x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();

        if (p.y < -p.r) {
          particles[i] = spawn(false);
        }
      }

      rafId = requestAnimationFrame(draw);
    }

    function start() {
      if (rafId) return;
      running = true;
      rafId = requestAnimationFrame(draw);
    }

    function stop() {
      running = false;
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    resize();
    buildParticles();
    start();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        resize();
      }, 150);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            start();
          } else {
            stop();
          }
        });
      });
      io.observe(header);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
